import styled from "styled-components";

export const StyledLinkedinModal = styled.div`
  height: 300px;
`;
